module.exports = __webpack_public_path__ + "img/cross.b7e68fce.svg";